<template>
  <el-card>
    <el-form-item>
      <el-input-number v-model="params.num" controls-position="right" :min="0"></el-input-number>
    </el-form-item>
    <el-form-item>
      <el-button @click="printPreview" :loading="loading">预览</el-button>
      <el-button @click="print" :loading="loading">打印</el-button>
      <KfMessage ref="commitMessage"></KfMessage>
    </el-form-item>
    <el-form-item>
      <div id="divPrint">
        <img class="preview-img" :src="imageBase64" v-for="(imageBase64,index) in imageBase64List" :key="index"
             :style="'width:' + imageWidth + 'px; height:' + imageHeight + 'px;'" v-if="imageBase64.length > 0">
      </div>
    </el-form-item>
  </el-card>
</template>

<script>


export default {
  name: "BusGlassTestPrintPreview",

  props: {
    parentData: {
      type: Object,
      default() {
        return {}
      }
    },
    setting: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data() {
    return {
      //num: 0,
      imageBase64: '',
      imageHeight: 310,
      imageWidth: 820,
      imageBase64List: [],
      loading: false,
      printDto: {},
      params: {
        parentData: {},
        num: 0,
      }
    }
  },
  methods: {

    async printPreview() {
      this.imageBase64List = []
      this.loading = true;
      await this.$axios.post('bus/print/createBoLiLabel', this.params).then(response => {
        this.loading = false;
        let res = response.data

        if (res.code !== 0) {
          return this.$message.error(res.message);
        } else {
          this.printDto = res.data;
          for (let i = 0; i < res.data.length; i++) {
            this.imageBase64 = res.data[i].imageBase64 || '';
            if (this.imageBase64.length > 0) {
              this.imageBase64 = "data:image/jpeg;base64," + this.imageBase64;
              this.imageBase64List.push(this.imageBase64);
            }
          }
        }

      }, error => {
        this.loading = false;
        this.$refs.commitMessage.showError(`生成打印图像失败，${error.message}`);
      })
    },
    async print() {
      this.imageBase64List = []
      this.loading = true;
      let {data: res} = await this.$axios.post('bus/print/boLiBatchPrint',this.params);
      if (res.code !== 0) {
        this.loading = false;
        this.$message.error(res.message)
      }else {
        this.loading = false;
        for (let i = 0; i < res.data.length; i++) {
          this.imageBase64 = res.data[i].imageBase64 || '';
          if (this.imageBase64.length > 0) {
            this.imageBase64 = "data:image/jpeg;base64," + this.imageBase64;
            this.imageBase64List.push(this.imageBase64);
          }
        }
        this.$message.success('打印成功！')
        this.parentData.printed_count = this.parentData.printed_count + this.params.num;
      }
    }
    ,
    async updatePrintedCount() {
      this.params.parentData.printed_count = this.parentData.printed_count+this.params.num
      await this.$axios.post('bus/print/updatePrintedCount', this.params).then(response => {
        let res = response.data
        console.log(res)
        this.setting.$fn.reSearch();
      })
    }
    ,
    async addPrintRecord(i) {
      await this.$axios.post('bus/print/addPrintRecord', this.printDto[i]).then(response => {
        let res = response.data
        console.log(res)
      })
    },
    printDiv() {
      //打印div
      //打开一个新窗口newWindow
      var newWindow = window.open("打印窗口", "_blank");
      //要打印的div的内容
      var docStr = document.getElementById("divPrint").innerHTML;
      //打印内容写入newWindow文档
      newWindow.document.write(docStr);
      //关闭文档
      newWindow.document.close();

      //调用打印机
      setTimeout(() => {
        newWindow.print();
        newWindow.close();
      }, 50);

      this.parentData.printed_count = this.parentData.printed_count + this.params.num;
      this.updatePrintedCount();
      console.log(this.printDto)
      this.addPrintRecord();

      return false;
    }

  },
  created() {
    this.params.parentData = this.parentData
  }
}

</script>

<style scoped>

.preview-img {
  width: 402px;
  height: 322px;
  border: solid 1px #a1a1a1;
}
</style>
